import React, { useEffect } from "react"
import { Divider, componentStyles, Box } from "@mallardbay/lib-react-components"

import SidebarEmbedded from "~components/shared/sidebar/sidebar-embedded"
import SidebarDrawer from "~components/shared/sidebar/sidebar-drawer"
import { usePageLayout } from "~contexts/page-layout-provider"
import { useIsTablet } from "~utils/hooks/use-is-tablet"
import {
    useIsEitherCalendarPage,
    useIsSmartSchedulePage,
} from "~utils/hooks/route-helpers"

export default function Sidebar() {
    const styles = useStyles()

    const { isMobile, closeSidebar } = usePageLayout()
    const shouldAutoCollapseNav = useShouldAutoCollapseNav()

    useEffect(() => {
        if (shouldAutoCollapseNav) {
            closeSidebar()
        }
    }, [shouldAutoCollapseNav])

    return (
        <>
            {!isMobile && (
                <Box style={styles.inlineSidebarContainer}>
                    <SidebarEmbedded />
                    <Divider />
                </Box>
            )}
            {isMobile && <SidebarDrawer />}
        </>
    )
}

function useStyles() {
    return componentStyles({
        inlineSidebarContainer: {
            position: "sticky",
            top: 0,
            left: 0,
            display: { base: "none", md: "flex" },
            height: "100vh",
            flexDirection: "row",
            justifyContent: "space-between",
        },
    })
}

function useShouldAutoCollapseNav() {
    // Auto collapse nav bar on the calendar page for tablets to default to a better calendar view
    const isCalendarRoute = useIsEitherCalendarPage()
    const isSmartScheduleRoute = useIsSmartSchedulePage()
    const shouldRouteCollapseOnTablet = isCalendarRoute || isSmartScheduleRoute
    const isTablet = useIsTablet()

    return shouldRouteCollapseOnTablet && isTablet
}
